import { useWsmKitConfigListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmKitListPage from "../components/WsmKitListPage/WsmKitListPage";

const PAGINATE_BY = 20;

export const WsmKitListView = () => {
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmKitConfigListQuery({
    variables: {
      ...paginationState,
      filter: query ? { search: query } : {},
    },
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmKitConfigs?.pageInfo,
    paginationState,
  );

  return (
    <WsmKitListPage
      kits={loading ? undefined : (mapEdgesToItems(data?.wsmKitConfigs) ?? [])}
      query={query}
      rowNumber={rowNumber}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onRowNumberChange={value => {
        setRowNumber(value);
        setPaginationState({});
      }}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmKitListView;
